module.exports = __webpack_public_path__ + "img/trashcan.aed2925f.svg";